import runtimeConfigLoader from '@/runtime-config-loader';
import io from 'socket.io-client';

type eventListener<T extends object> = (eventPayload: T) => void;
const eventListeners: { [eventName: string]: eventListener<any>[] } = {};
let socket: SocketIOClient.Socket;
export default {
    async run () {
        const config = await runtimeConfigLoader;
        if (socket) {
            socket.disconnect();
        }
        socket = io.connect(config.eventBroadcasterUrl);
        socket.on('event', (event: { eventName: string; payload: any }) => {
            (eventListeners[event.eventName] || [])
                .forEach(l => l(event.payload));
        });
    },
    stop () {
        if (socket) {
            socket.disconnect();
        }
    },
    registerListener<T extends object>(eventName: string, listener: eventListener<T>) {
        eventListeners[eventName] = eventListeners[eventName] || [];
        eventListeners[eventName].push(listener);
    },
    removeListener(eventName: string, listener: eventListener<any>) {
        eventListeners[eventName] = (eventListeners[eventName] || []).filter(l => l !== listener);
    }
};
